import React from 'react';

const LogoStubIcon = () => {
	return (
		<svg
			data-testid='logo-stub'
			fill='none'
			height='101'
			viewBox='0 0 100 101'
			width='100'
		>
			<path
				d='M0 50.5C0 22.8858 22.3858 0.5 50 0.5V0.5C77.6142 0.5 100 22.8858 100 50.5V50.5C100 78.1142 77.6142 100.5 50 100.5V100.5C22.3858 100.5 0 78.1142 0 50.5V50.5Z'
				fill='#E6E6E6'
			/>
			<path
				d='M57.8125 45.0312C57.8125 45.6529 57.5656 46.249 57.126 46.6885C56.6865 47.1281 56.0904 47.375 55.4688 47.375C54.8471 47.375 54.251 47.1281 53.8115 46.6885C53.3719 46.249 53.125 45.6529 53.125 45.0312C53.125 44.4096 53.3719 43.8135 53.8115 43.374C54.251 42.9344 54.8471 42.6875 55.4688 42.6875C56.0904 42.6875 56.6865 42.9344 57.126 43.374C57.5656 43.8135 57.8125 44.4096 57.8125 45.0312V45.0312ZM70.3125 36.4375V61.4375V64.5625C70.3125 65.3913 69.9833 66.1862 69.3972 66.7722C68.8112 67.3583 68.0163 67.6875 67.1875 67.6875H32.8125C31.9837 67.6875 31.1888 67.3583 30.6028 66.7722C30.0167 66.1862 29.6875 65.3913 29.6875 64.5625V58.3125V36.4375C29.6875 35.6087 30.0167 34.8138 30.6028 34.2278C31.1888 33.6417 31.9837 33.3125 32.8125 33.3125H67.1875C68.0163 33.3125 68.8112 33.6417 69.3972 34.2278C69.9833 34.8138 70.3125 35.6087 70.3125 36.4375ZM67.1875 57.668V36.4375H32.8125V54.543L39.9805 47.375C40.5688 46.7953 41.3616 46.4704 42.1875 46.4704C43.0134 46.4704 43.8062 46.7953 44.3945 47.375L53.125 56.1055L57.168 52.0625C57.7563 51.4828 58.5491 51.1579 59.375 51.1579C60.2009 51.1579 60.9937 51.4828 61.582 52.0625L67.1875 57.668Z'
				fill='#B3B3B3'
			/>
		</svg>
	);
};

export default LogoStubIcon;
